<div
  class="tw-flex md:tw-flex-row tw-flex-col tw-m-[20px] md:tw-w-[630px] tw-w-[350px] tw-overflow-x-auto"
>
  <div class="tw-flex tw-flex-col md:tw-ml-3 md:tw-w-1/2 tw-full">
    <ul
      class="list-group tw-rounded *:dark:tw-text-gray-100 *:tw-flex *:tw-justify-between *:tw-items-center *:tw-py-3 *:flex-wrap"
    >
      <!-- mciCount -->
      <li class="list-group-item list-group-bg">
        <div class="tw-flex">
          <span class="tw-ml-1"
            >{{ pageVocabs + "mciCount" | translate }}
          </span>
          <img [src]="mciImage" class="tw-mx-1" width="20" alt="mci" />
        </div>
        <span class="value">{{ model?.mciCount | numberSeparator }}</span>
      </li>

      <!-- mtnCount -->
      <li class="list-group-item list-group-bg">
        <div class="tw-flex">
          <span class="tw-ml-1"
            >{{ pageVocabs + "mtnCount" | translate }}
          </span>
          <img
            src="/assets/media/svg/operator/mtn.svg"
            class="tw-mx-1"
            width="20"
            alt="mtn"
          />
        </div>
        <span class="value">{{ model?.mtnCount | numberSeparator }}</span>
      </li>

      <!-- rightelCount -->
      <li class="list-group-item list-group-bg">
        <div class="tw-flex">
          <span class="tw-ml-1"
            >{{ pageVocabs + "rightelCount" | translate }}
          </span>
          <img [src]="rightelImage" class="tw-mx-1" width="20" alt="rightel" />
        </div>
        <span class="value">{{ model?.rightelCount | numberSeparator }}</span>
      </li>

      <!-- otherCount -->
      <li class="list-group-item list-group-bg">
        <span>{{ pageVocabs + "otherCount" | translate }} </span>
        <span class="value">{{ model?.otherCount | numberSeparator }}</span>
      </li>

      <!-- internationalCount -->
      <li class="list-group-item list-group-bg">
        <span>{{ pageVocabs + "internationalCount" | translate }} </span>
        <span class="value">{{
          model?.internationalCount | numberSeparator
        }}</span>
      </li>

      <!-- resolutionOfParliamentPrice -->
      <li class="list-group-item list-group-bg">
        <span
          >{{ pageVocabs + "resolutionOfParliamentPrice" | translate }}
        </span>
        <div class="tw-font-medium tw-text-lg">
          <span>{{
            model?.resolutionOfParliamentPrice | numberSeparator
          }}</span>
          <small class="tw-mr-[2px] ltr:tw-ml-[2px] tw-text-[12px]">{{
            "common.currency" | translate
          }}</small>
        </div>
      </li>

      <!-- resolutionPrice -->
      <li class="list-group-item list-group-bg">
        <span>{{ pageVocabs + "resolutionPrice" | translate }} </span>
        <div class="tw-font-medium tw-text-lg">
          <span>{{
            model?.sendPrice - model?.resolutionOfParliamentPrice
              | numberSeparator
          }}</span>
          <small class="tw-mr-[2px] ltr:tw-ml-[2px] tw-text-[12px]">{{
            "common.currency" | translate
          }}</small>
        </div>
      </li>
    </ul>

    <div class="tw-mt-3">
      <!-- smsParts -->
      <list-group-item
        [label]="pageVocabs + 'smsParts' | translate"
        [isShowValue]="false"
      >
        <div
          class="tw-bg-[#e4e3e3] dark:tw-bg-[#15152de4] tw-min-w-[60px] tw-h-[30px] tw-flex tw-rounded-[50px] tw-justify-center tw-items-center tw-text-center tw-font-bold"
          content
        >
          <span
            class="tw-font-bold tw-text-[15px] tw-text-black dark:tw-text-gray-200"
            >{{ model?.smsParts | numberSeparator }}</span
          >
        </div>
      </list-group-item>

      <!-- sendPrice -->
      <list-group-item
        [label]="pageVocabs + 'sendPrice' | translate"
        [isShowValue]="false"
      >
        <div
          class="tw-bg-[#36b7863d] tw-min-w-[60px] tw-max-w-[200px] tw-h-[30px] tw-px-[6px] tw-flex tw-rounded-[50px] tw-justify-center tw-items-center tw-text-[#33785e] dark:tw-text-green-600 tw-text-center"
          content
        >
          <div class="tw-text-lg">
            <span class="tw-font-bold tw-text-[15px]">{{
              model?.sendPrice | numberSeparator
            }}</span>
            <small
              class="tw-mr-[2px] ltr:tw-ml-[2px] tw-text-[11px] dark:tw-text-green-600!"
              >{{ "common.currency" | translate }}</small
            >
          </div>
        </div>
      </list-group-item>
    </div>
  </div>

  <!-- sms preview -->
  <div class="md:tw-w-1/2 tw-full">
    <section class="tw-w-full md:tw-mt-0 tw-mt-6">
      <nav
        ngbNav
        #nav="ngbNav"
        class="nav-tabs tw-flex tw-justify-center tw-h-[41px] border-bottom tw-text-center"
        [destroyOnHide]="false"
        [activeId]="selectedMode"
        (activeIdChange)="onChangeMode($event)"
      >
        <!-- ios -->
        <ng-container [ngbNavItem]="'ios'">
          <a
            ngbNavLink
            class="tw-flex-center border bg-transparent"
            style="flex: 1"
            [matTooltip]="'common.iosPreview' | translate"
          >
            <i class="mdi mdi-apple-ios text-info tw-mr-1 mdi-24px"></i>
          </a>

          <!-- ios Mobile -->
          <ng-template ngbNavContent>
            <div
              class="tw-flex tw-justify-center md:tw-mx-5 tw-relative tw-h-[430px]"
            >
              <!--mobile Img -->
              <img
                [src]="
                  appStateService.currentThemeMode() == 'light'
                    ? '/assets/media/mobile/ios.png'
                    : '/assets/media/mobile/ios-dark.png'
                "
                class="tw-h-full md:tw-w-[80%] tw-w-[60%] tw-object-cover"
                alt="ios"
              />

              <!-- logo -->
              <img
                alt="Logo"
                class="tw-absolute tw-object-cover lg:tw-w-[45px] lg:tw-h-[45px] lg:tw-top-[26px] lg:tw-left-[116px] md:tw-w-[43px] md:tw-h-[43px] md:tw-top-[27px] md:tw-left-[118px] tw-top-[29px] tw-left-[154px] tw-w-[43px] tw-h-[43px] tw-rounded-full"
                [src]="agentLogo || '/assets/media/logos/logo.png'"
              />

              <!--sender Number -->
              <p
                class="tw-absolute lg:tw-top-[67px] md:tw-top-[65px] tw-top-[66px] tw-right-0 tw-left-0 tw-font-bold tw-text-base tw-text-gray-600 dark:tw-text-gray-400 tw-text-center"
              >
                {{ senderNumber }}
              </p>

              <!-- message -->
              <div
                class="tw-absolute tw-overflow-y-auto lg:tw-h-[280px] lg:tw-top-[85px] lg:tw-left-[45px] lg:tw-w-[175px] md:tw-top-[84px] tw-top-[87px] md:tw-left-[43px] tw-left-[79px] md:tw-w-[190px] tw-h-[280px] tw-w-[174px] message-scroll"
              >
                <div class="tw-relative">
                  <div
                    class="tw-absolute lg:tw-top-[12px] md:tw-top-[15px] tw-top-[10px] tw-left-[15px] lg:tw-left-[16px] md:tw-left-[12px] tw-bg-[#eee] dark:tw-bg-[#26252C] tw-rounded-[20px] tw-mb-3 tw-p-3 message"
                  >
                    <div
                      class="tw-max-w-[140px] sms-preview tw-whitespace-break-spaces"
                    >
                      <div
                        class="tw-text-lg tw-font-medium message-text tw-px-3 tw-break-words font-vazir-ui"
                      >
                        {{ model?.smsBody ?? model?.smsText }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <!-- android -->
        <ng-container [ngbNavItem]="'android'">
          <a
            ngbNavLink
            class="tw-flex-center border bg-transparent"
            style="flex: 1"
            [matTooltip]="'common.androidPreview' | translate"
          >
            <i class="mdi mdi-android text-success tw-mr-1 mdi-24px"></i>
          </a>

          <!-- 1 -->
          <ng-template ngbNavContent>
            <div
              class="tw-flex tw-h-[430px] tw-justify-center md:tw-mx-5 tw-relative md:tw-mt-0 tw-mt-5"
            >
              <!--mobile Img -->
              <img
                [src]="
                  appStateService.currentThemeMode() == 'light'
                    ? '/assets/media/mobile/android.png'
                    : '/assets/media/mobile/android-dark.png'
                "
                class="tw-h-full md:tw-w-[80%] tw-w-[60%] tw-object-cover"
                alt="android"
              />

              <!-- logo -->
              <img
                alt="Logo"
                class="tw-absolute tw-object-cover lg:tw-w-[35px] lg:tw-h-[35px] lg:tw-top-[35px] lg:tw-left-[64px] md:tw-w-[35px] md:tw-h-[33px] md:tw-top-[38px] md:tw-left-[65px] tw-w-[33px] tw-h-[31px] tw-top-[38px] tw-left-[102px] tw-rounded-full"
                [src]="agentLogo || '/assets/media/logos/logo.png'"
              />

              <!--sender Number -->
              <p
                class="tw-absolute lg:tw-top-[48px] lg:tw-left-[106px] tw-top-[47px] dark:tw-text-gray-400 md:tw-top-[48px] md:tw-left-[105px] tw-left-[138px] tw-font-bold tw-text-base tw-text-gray-600"
              >
                {{ senderNumber }}
              </p>

              <!-- message -->
              <div
                class="tw-absolute lg:tw-top-[78px] lg:tw-left-[41px] lg:tw-w-[194px] lg:tw-h-[307px] md:tw-top-[73px] tw-top-[78px] md:tw-left-[40px] tw-left-[77px] md:tw-w-[183px] tw-h-[292px] tw-w-[180px] tw-overflow-y-auto message-scroll"
              >
                <div class="tw-relative">
                  <div
                    class="tw-absolute tw-bg-gray-200 dark:tw-bg-[#2f2f31] lg:tw-top-[10px] md:tw-top-[15px] tw-top-[13px] lg:tw-left-[10px] md:tw-left-[10px] tw-left-[10px] tw-rounded-lg tw-p-3"
                  >
                    <div
                      class="tw-max-w-[140px] sms-preview tw-whitespace-break-spaces"
                    >
                      <div
                        class="tw-text-lg tw-font-medium message-text tw-px-3 tw-break-words font-vazir-ui"
                      >
                        {{ model?.smsBody || model?.smsText }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>

        <!-- sms -->
        <ng-container [ngbNavItem]="'sms'">
          <a
            ngbNavLink
            class="tw-flex-center border bg-transparent"
            style="flex: 1"
            [matTooltip]="'common.smsText' | translate"
          >
            <i class="mdi mdi-message text-navyBlue tw-mr-1 mdi-19px"></i>
          </a>

          <!-- 1 -->
          <ng-template ngbNavContent>
            <!-- smsText -->
            <div
              class="list-group-item tw-border tw-border-gray-100 dark:tw-border-dark-100 dark:tw-bg-dark-100/80 tw-rounded-md dark:tw-text-gray-100 tw-h-[424px] tw-flex tw-justify-start flex-column tw-py-4 tw-my-2 tw-whitespace-pre-wrap tw-overflow-y-auto dir-rtl tw-text-right rounded-1"
            >
              <div
                class="tw-flex tw-justify-start tw-items-center tw-border-b dark:tw-border-dark-100 tw-text-gray-700 dark:tw-text-gray-300 tw-pb-2"
              >
                <i class="mdi mdi-message-cog tw-ml-2 tw-mb-1 mdi-20px"></i>
                <span class="tw-font-medium"
                  >{{ "common.smsText" | translate }}
                </span>
              </div>
              <div
                class="font-vazir-ui tw-pt-5 tw-text-gray-600 dark:tw-text-gray-200 tw-text-[14px]"
                copyToClipboard
                style="direction: rtl"
              >
                {{ model?.smsBody || model?.smsText }}
              </div>
            </div>
          </ng-template>
        </ng-container>
      </nav>
      <div [ngbNavOutlet]="nav" class="tw-mt-2"></div>
    </section>
  </div>
</div>

<div
  class="tw-bg-white tw-bottom-0 tw-flex tw-justify-end tw-py-3 tw-px-5 tw-sticky tw-w-full dark:!tw-bg-[#262638] tw-z-[2]"
>
  <app-form-btns
    class="tw-w-full"
    (onClose)="onClose()"
    (onSubmit)="onSubmit()"
    customTitle="common.finalConfirmation"
  >
  </app-form-btns>
</div>
